import { LexerMatcherLibrary } from "../../text/lexer/LexerMatcherLibrary";
import { SourceInfo, SourceRange } from "../../text/lexer/parsing/SourceInfo";
import { BinaryExpression } from "../expressions/BinaryExpression";
import { GroupExpression } from "../expressions/GroupExpression";
import { RJExpressionNode } from "../expressions/RJExpressionNode";
import { RJExpressionNodeType } from "../expressions/RJExpressionNodeType";
import { RJToken } from "../expressions/RJToken";
import { RJParserMessages } from "../parsers/RJParserMessages";
import { RJLexer } from "../RJLexer";
import { RJParser } from "../RJParser";
import { Operator } from "./Operator";

export class GroupOperator extends Operator
{
  _symbols:string[];

  get startSymbol(){ return this._symbols[ 0 ]; }
  get endSymbol(){ return this._symbols[ 1 ]; }

  constructor( parser:RJParser, symbols:string[], type:string|RegExp = LexerMatcherLibrary.BRACKET_MATCHER.type )
  {
    super( parser );
    this.setStartToken( type, symbols[ 0 ] );
    this._symbols = symbols;
  }

  public isFromLeft():boolean
  {
    return true;
  }

  public processStartNode( nodes:RJExpressionNode[], index:number )
  {
    let startNode = nodes[ index ] as any as RJToken;
    
    let endIndex = this.findEndIndex( nodes, index + 1 );

   

    if ( endIndex === -1 )
    {
      this.processor.parser.error( RJParserMessages.missingCloseSymbolOfGroup, startNode.sourceInfo );
      return false;
    }

    let endNode = nodes[ endIndex ];

    console.log( "End-Index of group:", endIndex, endNode );

    let group = new GroupExpression( this._parser, SourceRange.combine( startNode.sourceRange, endNode.sourceRange ) );

    let length = ( endIndex - index ) + 1;
    let groupExpressions = RJExpressionNode.replaceRange( nodes, index, length, group );

    groupExpressions.shift();
    groupExpressions.pop();

    if ( groupExpressions.length == 0 )
    {
      return true;
    }

    console.log( "Processing group:", groupExpressions );

    this._parser.operatorProcessor.processExpressions( groupExpressions );

    if ( groupExpressions.length > 1 )
    {
      this.processor.parser.error( RJParserMessages.expressionCouldNotBeResolved, group.sourceInfo );
      return false;
    }

    group.setExpression( groupExpressions[ 0 ] );

    return true;
  }

  findEndIndex( nodes:RJExpressionNode[], index:number )
  {
    var level = 1;

    for ( let i = index; i < nodes.length; i++ )
    {
      if ( nodes[ i ].type !== RJExpressionNodeType.TOKEN )
      {
        continue;
      }

      var token = nodes[ i ] as RJToken;

      console.log( "searching for end", index, i, token.match, this._symbols[ 0 ], this._symbols[ 1 ] );

      if ( token.match === this._symbols[ 0 ] )
      {
        console.log( "is start", index, i, token.match, this._symbols[ 0 ], this._symbols[ 1 ] );
        level ++;
      }
      else if ( token.match === this._symbols[ 1 ] )
      {
        console.log( "is end", index, i, token.match, this._symbols[ 0 ], this._symbols[ 1 ] );
        level --;

        if ( level === 0 )
        {
          return i;
        }
      }
      
    }

    return -1;
  }
}


